import React, { cloneElement } from 'react';
import { ClipboardCheckIcon, LockIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
const ribbonItems = [{
  title: 'Skip the Line',
  subtext: 'Digital Paperwork',
  href: '/skip-the-line',
  icon: <ClipboardCheckIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-67" />
}, {
  title: 'Patient Portal',
  subtext: 'Secure Login',
  href: '/portal',
  icon: <LockIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-68" />
}, {
  title: 'Book Appointment',
  subtext: 'Schedule a Visit',
  href: '/book',
  icon: <CalendarIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-69" />
}, {
  title: 'Find Us',
  subtext: 'Directions & Parking',
  href: '/locations',
  icon: <MapPinIcon className="h-8 w-8" strokeWidth={1.5} data-id="element-70" />
}];
export function FastTrackDashboard() {
  return <>
      {/* Quick-Action Ribbon */}
      <nav className="bg-[#0A71B1] w-full" aria-label="Quick Actions" data-id="element-71">
        {/* Desktop: 4-column ribbon, 90px tall */}
        <div className="hidden sm:grid grid-cols-4 max-w-full" data-id="element-72">
          {ribbonItems.map((item, index) => <a key={item.title} href={item.href} className={`flex items-center justify-center gap-3 h-[90px] text-white transition-colors duration-200 hover:bg-[#085d91] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white ${index < ribbonItems.length - 1 ? 'border-r border-[#3a9ad4]' : ''}`} aria-label={`${item.title} — ${item.subtext}`} data-id="element-73">
              <span className="flex-shrink-0 opacity-90" data-id="element-74">{item.icon}</span>
              <div className="flex flex-col" data-id="element-75">
                <span className="text-[14px] font-bold uppercase tracking-wider leading-tight" data-id="element-76">
                  {item.title}
                </span>
                <span className="text-[11px] text-white/60 font-medium leading-tight mt-0.5" data-id="element-77">
                  {item.subtext}
                </span>
              </div>
            </a>)}
        </div>

        {/* Mobile: 2x2 compact grid */}
        <div className="sm:hidden grid grid-cols-2 p-4 gap-px bg-[#3a9ad4]" data-id="element-78">
          {ribbonItems.map(item => <a key={item.title} href={item.href} className="flex flex-col items-center justify-center gap-2 bg-[#0A71B1] py-5 px-3 text-white transition-colors duration-200 active:bg-[#085d91] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white min-h-[100px]" aria-label={`${item.title} — ${item.subtext}`} data-id="element-79">
              <span className="opacity-90" data-id="element-80">{item.icon}</span>
              <span className="text-[12px] font-bold uppercase tracking-wider text-center leading-tight" data-id="element-81">
                {item.title}
              </span>
              <span className="text-[10px] text-white/50 font-medium text-center leading-tight" data-id="element-82">
                {item.subtext}
              </span>
            </a>)}
        </div>
      </nav>

      {/* Mobile: Sticky bottom utility bar (persists for easy access while scrolling) */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0A71B1] border-t-[3px] border-[#C62828] shadow-[0_-4px_16px_rgba(0,0,0,0.2)]" role="navigation" aria-label="Quick Actions — Sticky" data-id="element-83">
        <div className="grid grid-cols-4 w-full" data-id="element-84">
          {ribbonItems.map((item, index) => <a key={item.title} href={item.href} className={`flex flex-col items-center justify-center gap-1 py-2.5 text-white transition-colors duration-200 active:bg-[#085d91] min-h-[60px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white ${index < ribbonItems.length - 1 ? 'border-r border-[#3a9ad4]' : ''}`} aria-label={item.title} data-id="element-85">
              {cloneElement(item.icon as React.ReactElement, {
            className: 'h-5 w-5',
            strokeWidth: 1.5
          })}
              <span className="text-[9px] font-bold uppercase tracking-wide leading-tight" data-id="element-86">
                {item.title === 'Book Appointment' ? 'Book' : item.title === 'Get Directions' ? 'Find Us' : item.title.split(' ')[0]}
              </span>
            </a>)}
        </div>
      </div>

      {/* Spacer for mobile sticky bar */}
      <div className="sm:hidden h-[60px]" aria-hidden="true" data-id="element-87" />
    </>;
}